export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./axis";



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/index.js
// module id = 996
// module chunks = 0